import { useModals } from '~/contexts/ModalsContext';
import { useSession } from '~/contexts/SessionContext';

interface BlockedActionParams {
  contextMessage?: string;
}

export function useAuthBlockedAction(
  callback: () => void,
  params?: BlockedActionParams,
) {
  const modals = useModals();
  const session = useSession();

  return () => {
    if (session.loggedIn) {
      return callback();
    } else {
      modals.openModal('loginRegister', {
        defaultView: 'login',
        skipOnboarding: true,
        onSuccessfulLogin: callback,
        contextMessage: params?.contextMessage,
      });
    }
  };
}
